import PropTypes from 'prop-types';

export const AuthorProps = {
    /**
     * username of author
     */
    username: PropTypes.string.isRequired,
    /**
     * image object for image
     */
    image: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
    }).isRequired,
    /**
     * optional credential of author
     */
    credential: PropTypes.string,
    /**
     * author user id.
     */
    userId: PropTypes.number,
    /**
     * user's email.
     */
    email: PropTypes.string,
    /**
     * user's location
     */
    location: PropTypes.string,
    /**
     * user community data including vip status, number of followers, number of connections
     */
    userCommunityData: PropTypes.object,
    /**
     * what the relation is for user to this user
     */
    relation: PropTypes.shape({
        isFollowing: PropTypes.bool,
        connectionStatus: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.string,
        ]),
    }),
    /**
     * public profile url
     */
    publicUrl: PropTypes.string,
};
